import { AnyObject } from '../../global.types.ts'

const addItemToTop = <T extends AnyObject>(prev: T[], item: T): T[] => {
  return [item, ...prev]
}

const addItemToBottom = <T extends AnyObject>(prev: T[], item: T): T[] => {
  return [...prev, item]
}

const updateItem = <T extends AnyObject>(prev: T[], updates: Partial<T>, index: number): T[] => {
  if (index < 0 || index > prev.length - 1) return prev

  return [...prev.slice(0, index), { ...prev[index], ...updates }, ...prev.slice(index + 1)]
}

const removeItem = <T extends AnyObject>(prev: T[], index: number): T[] => {
  return [...prev.slice(0, index), ...prev.slice(index + 1)]
}

const formsUtils = {
  arrays: {
    addItemToTop,
    addItemToBottom,
    updateItem,
    removeItem,
  },
}
export default formsUtils
